import { Routes } from "@angular/router";
import { AuthenticationGuard } from "@softline/auth";
import { DashboardGuard } from "./guards/dashboard.guard";

export const dashboardRoutes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./pages/dashboard/dashboard.page').then((m) => m.DashboardPage),
    canActivate: [AuthenticationGuard, DashboardGuard],
  },
]
